import { ReactNode } from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Enterprise } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { compactArray } from '@mews/fp';
import { TextKey, RouteName } from '@mews-commander/enums';
import { NewTabLink } from '@mews-commander/ui';
import { useResolveRoute } from '@mews/routing';
import { DeletePropertyCell } from './DeletePropertyCell';

interface PropertiesTableColumns {
    removalDisabled: boolean;
    onRowDelete: (id: string) => void;
    userId: string;
    isReadOnly: boolean;
}

const columnHelper = createColumnHelper<Enterprise>();

const Link = ({ enterpriseId, children }: { enterpriseId: string; children: ReactNode }) => (
    <NewTabLink
        as={NewTabLink}
        standalone
        variant="basic"
        url={useResolveRoute()(RouteName.DashboardIndex, { currentEnterpriseId: enterpriseId })}
    >
        {children}
    </NewTabLink>
);

export const useColumns = ({ onRowDelete, removalDisabled, userId, isReadOnly }: PropertiesTableColumns) =>
    compactArray([
        columnHelper.accessor('name', {
            header: () => <LocalizedText textKey={TextKey.PropertyName} />,
            cell: (props) => <Link enterpriseId={props.row.original.id}>{props.getValue()}</Link>,
            enableSorting: true,
        }),
        isReadOnly
            ? null
            : columnHelper.display({
                  id: 'actions',
                  meta: { width: 64, align: 'end' },
                  cell: (props) => (
                      <DeletePropertyCell
                          disabled={removalDisabled}
                          enterpriseId={props.row.original.id}
                          propertyName={props.row.original.name}
                          userId={userId}
                          onDelete={() => onRowDelete(props.row.original.id)}
                      />
                  ),
              }),
    ]);
